import { GearPage } from "../components/GearPage";
import { HEROES, AV_GEAR_LIST } from "../data/gear";

export default function AVGearList({ onQuote }) {
  return (
    <GearPage
      testid="av-gear-list-page"
      hero={HEROES.avGearList}
      eyebrow="AV Gear List"
      title="Our full AV inventory"
      intro="Projectors, screens, mixers, wireless mics, powered speakers, large-format monitors, lighting and off-grid power — all delivered, set up and torn down for you."
      banner="✓ Professional setup & teardown included on every booking"
      gear={AV_GEAR_LIST}
      onQuote={onQuote}
    />
  );
}
